import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.algorithm');
import { OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-algorithm',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.algorithm/view.scss */
:host {
  display: block;
  height: 100%;
}

.project-page {
  min-height: 100%;
  width: 100%;
  background: #fff;
  color: #37352f;
}

.cover {
  height: 140px;
  background: linear-gradient(115deg, #e8f3ef, #edf1fa 60%, #f8efdf);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #687f80;
  letter-spacing: 4px;
  font-size: 11px;
}

main {
  width: 100%;
  max-width: none;
  margin: -28px 0 0;
  padding: 0 clamp(28px, 5vw, 72px) 70px;
  position: relative;
}

.page-icon {
  font-size: 56px;
  margin-bottom: 22px;
}

.breadcrumb, .caption, .section-title > span {
  font-size: 12px;
  color: #92928c;
}

.breadcrumb {
  margin-bottom: 18px;
}

.heading, .section-title {
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
}

h1 {
  font-size: 42px;
  font-weight: 750;
  letter-spacing: -1.5px;
  margin: 0;
}

.subtitle {
  color: #77766f;
  font-size: 18px;
  margin: 8px 0 26px;
}

.badge {
  background: #edf3ef;
  color: #537362 !important;
  padding: 5px 9px;
  border-radius: 0;
  font-size: 12px;
  white-space: nowrap;
}

.intro {
  padding: 19px 22px;
  background: #f5f7f5;
  border-radius: 0;
}

p {
  font-size: 14px;
  line-height: 1.85;
  margin: 8px 0 0;
}

.properties {
  margin: 22px 0 36px;
  padding: 12px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.property {
  display: flex;
  padding: 6px 0;
  font-size: 13px;
  gap: 20px;
}

.property > span {
  width: 130px;
  flex-shrink: 0;
  color: #92928c;
}

.property strong {
  font-weight: 500;
}

section {
  margin-top: 34px;
}

h2 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 16px;
}

h3 {
  font-size: 16px;
  font-weight: 650;
  margin: 0;
}

.method-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: #e7e7e3;
}

.method {
  border: 0;
  border-radius: 0;
  padding: 22px;
  background: #fff;
}

.method small {
  display: block;
  font-size: 11px;
  color: #93938d;
  margin-top: 5px;
}

.method p {
  color: #73736d;
  font-size: 13px;
}

.experiment {
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #fafaf8;
  border: 1px solid #eeeee9;
  border-radius: 0;
}

.scale, .conditions {
  padding: 22px;
}

.scale {
  border-right: 1px solid #e7e7e3;
}

.scale > span {
  font-size: 10px;
  letter-spacing: 2px;
  color: #6d8c7a;
  display: block;
  margin-bottom: 9px;
}

ul {
  padding-left: 18px;
  font-size: 13px;
  line-height: 2;
  margin: 9px 0 0;
  color: #77776f;
}

.table-scroll {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  text-align: left;
}

th {
  background: #f7f7f4;
  color: #85857e;
  font-weight: 500;
}

th, td {
  padding: 12px 14px;
  border-bottom: 1px solid #eee;
}

td:first-child {
  font-weight: 550;
  white-space: nowrap;
}

td:nth-child(2) {
  white-space: nowrap;
  color: #85857e;
}

.chart-plan {
  display: flex;
  gap: 20px;
  padding: 24px;
  border: 1px dashed #d7ddd7;
  border-radius: 0;
}

.chart-icon {
  font-size: 35px;
  color: #6e8b79;
}

.chart-plan p {
  color: #7d7d75;
}

.step {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 14px 0;
  border-bottom: 1px solid #eee;
  background: transparent;
}

.step:hover {
  background: #fafaf8;
}

.checkbox {
  width: 19px;
  height: 19px;
  border: 1px solid #ccc;
  border-radius: 0;
  text-align: center;
  font-size: 12px;
  flex-shrink: 0;
}

.checked {
  background: #6d8878;
  color: white;
  border-color: #6d8878;
}

.step-number {
  color: #b4b4ad;
  font-size: 12px;
}

.step-copy {
  flex: 1;
}

.step-copy strong {
  font-size: 14px;
  font-weight: 500;
  display: block;
}

.step-copy small {
  font-size: 12px;
  color: #96968d;
  display: block;
  margin-top: 4px;
}

.step-status {
  font-size: 11px;
  color: #8a8a82;
  padding: 3px 8px;
  background: #f4f4ef;
  border-radius: 0;
}

.note-input, .note {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

input {
  flex: 1;
  min-width: 0;
  border: 0;
  background: transparent;
  font-size: 14px;
  outline: none;
}

.note-input button, .note button {
  font-size: 12px;
  color: #718675;
  padding: 5px 8px;
}

.note > span {
  flex: 1;
  font-size: 14px;
  overflow-wrap: anywhere;
}

.note small {
  color: #aaa;
  font-size: 11px;
}

.save-message {
  color: #718675;
  font-size: 12px;
}

button:focus-visible, input:focus-visible {
  outline: 2px solid #718675;
  outline-offset: 3px;
}

@media (max-width: 700px) {
  main {
    padding: 0 20px 50px;
  }
  .method-grid, .experiment {
    grid-template-columns: 1fr;
  }
  .scale {
    border-right: 0;
    border-bottom: 1px solid #eee;
  }
  .heading, .section-title {
    flex-wrap: wrap;
    gap: 4px;
  }
  h1 {
    font-size: 34px;
  }
  .property > span {
    width: 110px;
  }
  .chart-plan {
    padding: 16px;
  }
}
.algorithm-header {
  padding: 28px 36px 0;
}
.algorithm-header h1 {
  font-size: 24px;
  font-weight: 700;
  color: #123c45;
  margin-bottom: 18px;
  letter-spacing: normal;
}

.algorithm-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #dbe7e5;
}
.algorithm-tabs button {
  padding: 10px 4px;
  border-bottom: 3px solid transparent;
  background: transparent;
  font-size: 15px;
  color: #64748b;
  cursor: pointer;
}
.algorithm-tabs button[aria-selected=true] {
  border-bottom-color: #0d9488;
  color: #0f766e;
  font-weight: 700;
}
.algorithm-tabs button:focus-visible {
  outline: 2px solid #0d9488;
  outline-offset: 3px;
}

[role=tabpanel][hidden] {
  display: none !important;
}

@media (max-width: 800px) {
  .algorithm-header {
    padding: 24px 20px 0;
  }
  .algorithm-tabs {
    gap: 18px;
    flex-wrap: wrap;
  }
}`],
})
export class PageAlgorithmComponent implements OnInit, OnDestroy {
    public sectionView = 'description';
    @ViewChild('simulation') simulation: any;
    public async setSection(section: string, focus = false, event?: Event) {
        event?.preventDefault();
        this.sectionView = section;
        if (section === 'description') this.simulation?.stop();
        await this.service.render();
        if (focus) document.getElementById('algorithm-tab-' + section)?.focus();
    }
    public newNote = '';
    public savedMessage = '';
    public storageKey = 'ku-algorithm-newton-project';
    public steps = [
        { title: '2차원 시뮬레이션 환경 구성', detail: '뉴턴의 출발점·목적지와 보행자 이동 환경 정의', done: false },
        { title: 'Naive · VO · ORCA 기반 방식 구현', detail: '동일한 초기 조건과 보행자 경로로 비교', done: false },
        { title: '예비 실험 및 평가 기준 조정', detail: '군중 수·이동 패턴·안전거리·세부 지표 확정', done: false },
        { title: '군중 규모별 반복 실험', detail: '사람 수를 점차 늘리며 주행 성능과 Runtime 측정', done: false },
        { title: '결과 시각화 및 복잡도 분석', detail: '실측 실행 시간과 이론적 시간 복잡도 비교', done: false }
    ];
    public methods = [
        { name: 'Naive', label: '기준 방식', detail: '기본 회피 전략을 비교 기준으로 사용합니다. 구체적인 규칙은 구현 시 정의합니다.' },
        { name: 'VO', label: 'Velocity Obstacle', detail: '상대 위치와 속도로 충돌 가능성이 있는 속도를 피하는 방식을 비교합니다.' },
        { name: 'ORCA', label: 'Optimal Reciprocal Collision Avoidance', detail: '상호 회피 기반 방식을 비교합니다. 보행자의 회피 참여 여부도 실험 조건에 명시합니다.' }
    ];
    public metrics = [
        { name: '목적지 도달 시간', unit: '초 (s)', detail: '출발부터 도착까지의 시뮬레이션 시간' },
        { name: '전체 이동 거리', unit: '미터 (m)', detail: '로봇이 이동한 경로의 누적 길이' },
        { name: '충돌 / 안전거리 위반', unit: '횟수', detail: '충돌과 안전거리 위반을 구분하여 기록' },
        { name: '목적지 도달 성공 여부', unit: '성공 / 실패', detail: '제한 시간 내 도달 여부와 반복 실험 성공률' },
        { name: '알고리즘 실행 시간', unit: '밀리초 (ms)', detail: '회피 알고리즘 계산에 소요된 Runtime' },
        { name: '계산량 및 시간 복잡도', unit: '군중 수 n 기준', detail: '입력 크기에 따른 연산량과 실행 시간의 증가 추세' }
    ];
    public notes: any[] = [];
    private pageSubscription: any;
    private pageLocation = '';
    private defaults: any;
    private pageGeneration = 0;
    public pageState: any = null;
    public canEdit = false;
    public pageBusy = false;
    public pageError = '';
        private async pageRequest(action: string, data: any = {}) {
        const response: any = await wiz.app('component.page.share').call('handle', { action, data: JSON.stringify(data) });
        if (response.code !== 200) throw new Error(response.data?.message || response.message || '페이지를 불러오지 못했습니다.');
        return response.data;
    }

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }
    public async ngOnInit() {
        await this.service.init();
        this.defaults = JSON.parse(JSON.stringify({steps: this.steps, notes: this.notes}));
        this.pageLocation = location.href;
        this.pageSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && location.href !== this.pageLocation) {
                this.pageLocation = location.href;
                Object.assign(this, JSON.parse(JSON.stringify(this.defaults)));
                void this.loadPage().then(() => this.service.render());
            }
        });
        await this.loadPage();
        await this.service.render();
    }
    public async loadPage() {
        const generation = ++this.pageGeneration;
        this.canEdit = false;
        this.pageState = null;
        this.pageError = '';
        if (!this.service.auth.status) return;
        try {
            const state = await this.pageRequest('get', {path: '/algorithm', id: new URLSearchParams(location.search).get('share') || ''});
            if (generation !== this.pageGeneration) return;
            this.pageState = state;
            let data = this.pageState.content;
            if (this.pageState.role === 'owner' && this.pageState.version === 0) {
                try { data = JSON.parse(localStorage.getItem(this.storageKey) || 'null') || data; } catch {}
            }
            if (Array.isArray(data.done)) this.steps.forEach((step, i) => step.done = data.done[i] === true);
            if (Array.isArray(data.notes)) this.notes = data.notes.filter((n: any) => n && typeof n.text === 'string');
            this.canEdit = this.pageState.role !== 'viewer';
            if (this.pageState.role === 'owner' && this.pageState.version === 0) {
                await this.save();
                if (!this.pageError) localStorage.removeItem(this.storageKey);
            }
        } catch (error: any) { this.pageError = error.message; this.canEdit = false; }
    }
    public async save() {
        if (!this.canEdit || this.pageBusy) return;
        this.pageBusy = true;
        try {
            this.pageState = await this.pageRequest('save', {id: this.pageState.id, path: '/algorithm',
                version: this.pageState.version, content: {done: this.steps.map(s => s.done), notes: this.notes}});
            this.savedMessage = '페이지 기록을 서버에 저장했어요.';
            this.pageError = '';
        } catch (error: any) { this.pageError = error.message; this.canEdit = false; }
        finally { this.pageBusy = false; await this.service.render(); }
    }
    public async toggleStep(step: any) { if (!this.canEdit || this.pageBusy) return; step.done = !step.done; await this.save(); }
    public async addNote() {
        if (!this.canEdit || this.pageBusy || !this.newNote.trim()) return;
        this.notes.unshift({ text: this.newNote.trim(), date: new Date().toLocaleDateString('ko-KR') });
        this.newNote = '';
        await this.save();
    }
    public async removeNote(index: number) { if (!this.canEdit || this.pageBusy) return; this.notes.splice(index, 1); await this.save(); }
    public ngOnDestroy() { this.pageGeneration++; this.pageSubscription?.unsubscribe(); }
}

export default PageAlgorithmComponent;